/**
 * fallback for old builders that don't understand esModule require
 * @param require_result
 * @returns {string}
 */
export default function compatibleRequire(require_result) {
  if (typeof require_result === "object") {
    return require_result.default;
  }
  return require_result;
}